import { Modal, ModalWidth } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import ReactPlayer from 'react-player';
import { useGlobalModalContext } from '../../../GlobalModal';
import styles from './AnnouncementsVideoModal.module.scss';

const cx = classNames.bind(styles);

const AnnouncementsVideoModal = (): React.ReactElement => {
  const { closeModal } = useGlobalModalContext();

  return (
    <Modal width={ModalWidth.ExtraLarge} open onClose={closeModal} headerTitle="CreditSights 2023">
      <div className={cx('videoModal')}>
        <ReactPlayer
          url="/api/common/v1/media/videos/CreditSights_2023_FINAL.mp4"
          playing
          controls
          width="100%"
          height="100%"
        />
      </div>
    </Modal>
  );
};

export default AnnouncementsVideoModal;
